import { render, staticRenderFns } from "./BrandNavTreeMappings.vue?vue&type=template&id=424b357f&scoped=true"
import script from "./BrandNavTreeMappings.vue?vue&type=script&lang=js"
export * from "./BrandNavTreeMappings.vue?vue&type=script&lang=js"
import style0 from "./BrandNavTreeMappings.vue?vue&type=style&index=0&id=424b357f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "424b357f",
  null
  
)

export default component.exports